export default __webpack_public_path__ + "static/media/partnerImg3.f2827d45.png";